import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useUIStore = defineStore('ui', () => {
  // Vehicle dropdown state
  const openVehicleDropdownId = ref(null)

  const setVehicleDropdown = (vehicleId) => {
    openVehicleDropdownId.value = vehicleId
  }

  const closeVehicleDropdown = () => {
    openVehicleDropdownId.value = null
  }

  const isVehicleDropdownOpen = (vehicleId) => {
    return openVehicleDropdownId.value === vehicleId
  }

  return {
    openVehicleDropdownId,
    setVehicleDropdown,
    closeVehicleDropdown,
    isVehicleDropdownOpen
  }
})
